import styled, { keyframes } from 'styled-components/macro';
import { layout, LayoutProps } from 'styled-system';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

type RotateProps = LayoutProps;

export const Rotate = styled.div<RotateProps>`
  display: inline-block;
  animation: ${rotate} 2s linear infinite;
  line-height: 0;
  ${layout}
`;
